import { render } from "./FundingPage.vue?vue&type=template&id=4e6ca573&scoped=true"
import script from "./FundingPage.vue?vue&type=script&lang=js"
export * from "./FundingPage.vue?vue&type=script&lang=js"

import "./FundingPage.vue?vue&type=style&index=0&id=4e6ca573&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6ca573"]])

export default __exports__